import { render, staticRenderFns } from "./PrescriptManagerForm.vue?vue&type=template&id=9eb1ac92&"
import script from "./PrescriptManagerForm.vue?vue&type=script&lang=ts&"
export * from "./PrescriptManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports